var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/link/github"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.3333 15.2871C26.5824 15.2871 24.8486 15.632 23.2309 16.302C21.6132 16.9721 20.1434 17.9542 18.9052 19.1924C16.4048 21.6928 15 25.0842 15 28.6204C15 34.5138 18.8267 39.5138 24.12 41.2871C24.7867 41.3938 25 40.9804 25 40.6204V38.3671C21.3067 39.1671 20.52 36.5804 20.52 36.5804C19.9067 35.0338 19.04 34.6204 19.04 34.6204C17.8267 33.7938 19.1333 33.8204 19.1333 33.8204C20.4667 33.9138 21.1733 35.1938 21.1733 35.1938C22.3333 37.2204 24.2933 36.6204 25.0533 36.3004C25.1733 35.4338 25.52 34.8471 25.8933 34.5138C22.9333 34.1804 19.8267 33.0338 19.8267 27.9538C19.8267 26.4738 20.3333 25.2871 21.2 24.3404C21.0667 24.0071 20.6 22.6204 21.3333 20.8204C21.3333 20.8204 22.4533 20.4604 25 22.1804C26.0533 21.8871 27.2 21.7404 28.3333 21.7404C29.4667 21.7404 30.6133 21.8871 31.6667 22.1804C34.2133 20.4604 35.3333 20.8204 35.3333 20.8204C36.0667 22.6204 35.6 24.0071 35.4667 24.3404C36.3333 25.2871 36.84 26.4738 36.84 27.9538C36.84 33.0471 33.72 34.1671 30.7467 34.5004C31.2267 34.9138 31.6667 35.7271 31.6667 36.9671V40.6204C31.6667 40.9804 31.88 41.4071 32.56 41.2871C37.8533 39.5004 41.6667 34.5138 41.6667 28.6204C41.6667 26.8695 41.3218 25.1357 40.6517 23.518C39.9817 21.9003 38.9995 20.4305 37.7614 19.1924C36.5233 17.9542 35.0535 16.9721 33.4358 16.302C31.8181 15.632 30.0843 15.2871 28.3333 15.2871Z",
    fill: "#CCCCCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.0720dd982b55be82c11afc83f3802cbd.svg";
export { ForwardRef as ReactComponent };